import {InsolesModelSummaryModel} from "./insolesModelSummary.model";
import {IWithSummaryModel} from "../../../../common/permission/api/entity/iWithSummary.model";
import {LovValueSummary} from "../../../../common/lov/lov-value/api/model/lovValueSummary.model";
import {InsoleModelGabaritShoeSizeSummaryModel} from "./gabarit/insoleModelGabaritShoeSizeSummary.model";

export class InsolesModelModel implements IWithSummaryModel<InsolesModelSummaryModel>{
    summary: InsolesModelSummaryModel;
    material: LovValueSummary;
    gabaritShoeSizes: InsoleModelGabaritShoeSizeSummaryModel[] = [];
    active: boolean;
    canHaveBevel: boolean;
    camMethods: LovValueSummary[];
}